var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.838 61.8188L93.0249 128.086C87.7752 133.372 79.1661 133.174 74.1653 127.652L56.5352 108.185L62.4648 102.815L80.0949 122.282C82.0183 124.405 85.3295 124.482 87.3486 122.449L153.162 56.1814L158.838 61.8188Z",
    fill: "#39DF9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.5 161C134.466 161 162 133.466 162 99.5C162 91.5666 160.498 83.9841 157.762 77.0213L165.09 73.7918C168.258 81.7438 170 90.4185 170 99.5C170 137.884 138.884 169 100.5 169C62.1162 169 31 137.884 31 99.5C31 61.1162 62.1162 30 100.5 30C117.456 30 132.993 36.0719 145.057 46.1598L139.756 52.1563C129.105 43.3154 115.423 38 100.5 38C66.5345 38 39 65.5345 39 99.5C39 133.466 66.5345 161 100.5 161Z",
    fill: "#20A2E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmation);
export default __webpack_public_path__ + "static/media/confirmation.9872c0a8.svg";
export { ForwardRef as ReactComponent };